export const detectLeavePage = trackingVariable => ({
	beforeMount() {
		window.addEventListener("beforeunload", this.preventNav);
		this.$once("hook:beforeDestroy", () => {
			window.removeEventListener("beforeunload", this.preventNav);
		});
	},
	beforeRouteLeave(to, from, next) {
		if (this[trackingVariable]) {
			return this.mixinIsAcceptLeaveConfirm().then(isAccept => next(isAccept));
		}
		next();
	},
	methods: {
		preventNav(event) {
			if (!this[trackingVariable]) return;
			event.preventDefault();
			// Chrome requires returnValue to be set.
			event.returnValue = "";
		}
	}
});
